'use strict';

if(location.href === window.config.applanga.url || location.href === window.config.applanga.secondary_url ||location.href.endsWith('/projects')){
  location.href = '!/#/projects';
} else {
  angular.module('core')
  .config(['$analyticsProvider', function ($analyticsProvider) {
    // turn off automatic page view tracking
    $analyticsProvider.virtualPageviews(false);
  }])
  .run(['$rootScope', '$intercom', 'Authentication', 'ConfigData', function($rootScope, $intercom, Authentication, ConfigData) {
    var authentication = Authentication;

	  $rootScope.authentication = authentication;
	  $rootScope.whitelabel = window.whitelabel;
	  $rootScope.ConfigData = window.config;
	  
	  // Helper function which can get used in code and template to get
	  // white label settings
	  $rootScope.isWhiteLabelSettingActive = function(setting) {
	  	if ($rootScope.whitelabel && $rootScope.whitelabel.settings && $rootScope.whitelabel.settings.hasOwnProperty(setting)) {
	  		return $rootScope.whitelabel.settings[setting];
		}
		return false;
	  };


	  // Initialize Intercom
	  if (ConfigData && ConfigData.intercom) {
        var intercomConfig = ConfigData.intercom;
        var intercomUser = {
          app_id: intercomConfig.app_id
        };

        if (authentication.user && authentication.user._id) {
          intercomUser.name = authentication.user.firstName + ' '+authentication.user.lastName;
          intercomUser.email = authentication.user.email;
          intercomUser.hide_default_launcher = true;
        }

        $intercom.boot(intercomUser);
	  }
  }])

  .controller('HeaderController', [
  '$scope', 'Authentication', 'Menus', 'MobileApps', '$intercom', 'EventTracker', '$state', '$q',
  function ($scope, Authentication, Menus, MobileApps, $intercom, EventTracker, $state, $q) {
    $scope.authentication = Authentication;
    $scope.isCollapsed = false;
    $scope.menu = Menus.getMenu('topbar');

    //remove 'create app' link for whitelabeling
    if($scope.whitelabel)
    {
      Menus.removeSubMenuItem('topbar','projects/create');
    }

    $scope.toggleCollapsibleMenu = function () {
      $scope.isCollapsed = !$scope.isCollapsed;
    };


    // Because we use an old angular version we have to create that alias ourself
    $q.resolve = $q.when;

    // Sends the user data to the analytics provider
    EventTracker.identifyUser();

    // Collapsing the menu after navigation
    $scope.$on('$stateChangeSuccess', function () {
      $scope.isCollapsed = false;
        if($scope.authentication.user && $scope.authentication.user._id)
        {
            $scope.mobileApps = MobileApps.query();
        }
    });

    // Check if the user uses IE and display a banner if thats the case
    // https://stackoverflow.com/questions/24861073/detect-if-any-kind-of-ie-msie
    var isIE = !!navigator.userAgent.match(/Trident/g) || !!navigator.userAgent.match(/MSIE/g);
    if (isIE) {
      $('<style type="text/css">body { margin-top: 55px; } header { top: 55px !important; }</style>').appendTo('head');
      $('<div class="browser-not-supported">Applanga does not support Internet Explorer 11!<br />Please use <a href="https://www.google.com/chrome/" target="_blank">Google Chrome</a> for optimal experience.</div>').prependTo('body');
	}

    $scope.$on('intercom_event',function(evt,message){
      $intercom.trackEvent(message.eventName,message.data);
    });

    // Show the default intercom launcher only when user is not logged in
    $scope.$watch(function() { return $scope.authentication && $scope.authentication.user && $scope.authentication.user._id; }, function() {
    	var hideLauncher = false;
    	if ($scope.authentication.user && $scope.authentication.user._id) {
			hideLauncher = true;
		}
		$intercom.update({hide_default_launcher: hideLauncher});
	});

  //Showing go-to-VueJS-version banner
  $(document).ready(() => {
    const viewsExcluded = [
      'billings',
      'resend-email-verification',
      'password/reset',
      'supported-machine-translations',
      '4dm1n/users'
    ];

    // Checking if url is contains any excluded view
    if(viewsExcluded.some(item => location.href.includes(item))){
      $('.go-to-vuejs-banner').hide();
      return;
    }

    const showBanner = () => {
      setTimeout(() => {
        $('.go-to-vuejs-banner').addClass('on');
        $('.go-to-vuejs-banner').on('click', () => {
          let hasEntry, hasGroup, hasTag, hasFile,
              url = location.href.replace('#!', '!/#');
  
          if(url.includes('/entry/')){
            if(!$state.params.entryId && !$state.params.groupId){
              url = url.replace('/entry//group/','');
            } else {
              if($state.params.entryId){
                hasEntry = true;
                url = url.replace('/entry/','?entry=');
              } else {
                url = url.replace('/entry/','');
              }
              if($state.params.groupId){
                hasGroup = true;
                url = hasEntry ? 
                        url.replace('/group/','&group=') : 
                            url.replace('/group/','?group=');
              } else {
                url = url.replace('/group/','');
              }
            }
  
            if(url.includes('/tag/')){
              hasTag = true;
              url = (hasEntry || hasGroup) ?
                      url.replace('/tag/', '&tag=') :
                        url.replace('/tag/', '?tag=');
            }
  
            if(url.includes('/file/')){
              hasFile = true;
              url = (hasEntry || hasGroup || hasTag) ?
                      url.replace('/file/', '&file=') :
                        url.replace('/file/', '?file=');
            }
  
            if(url.includes('sourceLanguage')){
              if(hasEntry || hasGroup || hasTag || hasFile){
                url = url.replace('?sourceLanguage', '&sourceLanguage');
              } 
            }
  
            url = url
                    .replace('/edit', '&edit=true')
                    .replace('/new', '');
          }
  
          location.href = url;
        });
      }, 750);
    };

    // Checking if there's any loader active
    // before showing the banner, so that the
    // animation is smoother
    const intervalId = window.setInterval(function(){
      if($('.spinner-wrapper').is(':visible')){
        return;
      } else {
        clearInterval(intervalId);
        showBanner();
      }
    }, 1000);

  });

  }
]);
}